import axios from "axios";
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        stripeAuthenticated: true,
    },
    actions: {
        async stripeAuthStatus(ctx) {
            return axios.get("/api/v1/stripe/oauth/connected").then((result) => {
                ctx.commit("setStripeAuthenticated", result.data.connected);
                return result;
            });
        },
        async stripeAuthAccounts(ctx) {
            return axios.get("/api/v1/stripe/oauth/accounts");
        },
        async stripeAuthGetAccountById(ctx, { stripeAccountId }) {
            return axios.get(`/api/v1/stripe/oauth/account/${stripeAccountId}`);
        },
        async stripeAuthGetAccountsByUserId(ctx, { userId }) {
            return axios.get(`/api/v1/stripe/oauth/${userId}/accounts`);
        },
        async stripeAuthSetDefaultAccount(ctx, { stripeAccountId }) {
            return axios.post(`/api/v1/stripe/oauth/account/${stripeAccountId}/default`);
        },
        async stripeAuthRefreshAccount(ctx, { stripeAccountId }) {
            return axios.post(`/api/v1/stripe/oauth/account/${stripeAccountId}/refresh`);
        },
    },
    getters: {
        getStripeAuthenticated(state) {
            return state.stripeAuthenticated;
        },
    },
    mutations: {
        setStripeAuthenticated(state, payload) {
            state.stripeAuthenticated = payload;
        },
    },
};
